import { Injectable }       from "@angular/core";

import { 
    ApiService
}                           from "./api.service";
import {
    CtmApiLoader
}                           from "./api.loader.service";
import { 
    CtmTableData,
    ResponseMessage 
}                           from "../models";

@Injectable()
export class CtmTableService {
    constructor(
        private api: ApiService,
        private apiLoader: CtmApiLoader
    ) {
    }

    public loadData(table: CtmTableData): Promise<Object> {
        return new Promise((resolve, reject) => {
            if (table.controlManager != undefined) {
                table.controlManager.clear();
            }
            
            table.loading = true;
            if (table.loadAllData == true) {
                table.criteria.page = 1;
                table.criteria.paging = 500;
    
                this.continueLoadData(table, 0, resolve);
            }
            else {
                this.api.callApiController(table.url, {
                      type: "POST",
                      showLoading: table.showLoading,
                      data: table.criteria
                }).then(
                    (data) => {
                        if (data != undefined) {
                            if (table.customResult != undefined) {
                                table.customResult(data);
                            }

                            if (table.criteria.page != undefined) {
                                let totalPages = Math.ceil(data["TotalRecords"] / table.displayPage);
                                if (table.criteria.page > totalPages
                                    && totalPages > 0) {
                                    table.pageNumber = 1;
                                    table.criteria.page = 1;

                                    return this.loadData(table);
                                }
                            }

                            table.totalRecords = data["TotalRecords"];
                            table.rows = data["Rows"];
    
                            if (table.specialObject != undefined) {
                                for(let prop in table.specialObject) {
                                    table.specialObject[prop] = data[prop];
                                }
                            }
    
                            if (table.rows != undefined) {
                                let start = ((table.pageNumber - 1) * table.displayPage) + 1;
    
                                for (let idx = 0; idx < table.rows.length; idx++) {
                                    let row = table.rows[idx];
                                    row["rowNumber"] = start + idx;
    
                                    if (table.customRowData != undefined) {
                                        row = table.customRowData(row);
                                    }
                                    if (table.controlManager != undefined) {
                                        table.controlManager.addControl(row);
                                    }
                                }
                            }
                        }
                        else {
                            table.totalRecords = 0;
                            table.rows = [];
                        }
    
                        table.updatePaggingInfo();
    
                        table.loading = false;
                        table.loaded = true;
                
                        resolve();
                    }
                ).catch(() => {
                    table.totalRecords = 0;
                    table.rows = [];
                    table.updatePaggingInfo();
    
                    table.loading = false;
                    table.loaded = true;
    
                    resolve();
                });
            }
        });
    }

    private continueLoadData(table, rowCount: number, complete) {
        if (rowCount == 0) {
            if (table.showLoading == true) {
                this.apiLoader.show();
            }
        }

        this.api.callApiController(table.url, {
            type: "POST",
            showLoading: false,
            showError: false,
            data: table.criteria
        }).then(
            (data) => {
                if (data != undefined) {
                    if (rowCount == 0) {
                        if (table.customResult != undefined) {
                            table.customResult(data);
                        }
                        
                        let rowNumber = 1;
                        for (let idx = 0; idx < data["Rows"].length; idx++) {
                            let row = data["Rows"][idx];
                            row["rowNumber"] = rowNumber + idx;

                            if (table.customRowData != undefined) {
                                row = table.customRowData(row);
                            }
                            if (table.controlManager != undefined) {
                                table.controlManager.addControl(row);
                            }
                        }

                        table.totalRecords = data["TotalRecords"];
                        table.rows = data["Rows"];

                        if (table.specialObject != undefined) {
                            for(let prop in table.specialObject) {
                            table.specialObject[prop] = data[prop];
                            }
                        }

                        rowCount = table.rows.length;
                        if (rowCount >= table.totalRecords) {
                            table.updatePaggingInfo();

                            table.loading = false;
                            table.loaded = true;

                            if (table.showLoading == true) {
                                this.apiLoader.hide(500);
                            }
                            complete();
                        }
                        else {
                            table.criteria.page += 1;
                            this.continueLoadData(table, rowCount, complete);
                        }
                    }
                    else {
                        let rowNumber = 1;
                        if (table.rows != undefined) {
                            rowNumber = table.rows.length + 1;
                        }
                        for (let idx = 0; idx < data["Rows"].length; idx++) {
                            let row = data["Rows"][idx];
                            row["rowNumber"] = rowNumber + idx;

                            if (table.customRowData != undefined) {
                                row = table.customRowData(row);
                            }
                            if (table.controlManager != undefined) {
                                table.controlManager.addControl(row);
                            }
                        }

                        table.rows = table.rows.concat(data["Rows"]);

                        rowCount = table.rows.length;
                        if (rowCount >= table.totalRecords) {
                            table.updatePaggingInfo();

                            table.loading = false;
                            table.loaded = true;
                            
                            if (table.showLoading == true) {
                                this.apiLoader.hide(500);
                            }
                            complete();
                        }
                        else {
                            table.criteria.page += 1;
                            this.continueLoadData(table, rowCount, complete);
                        }
                    }
                }
                else {
                    table.totalRecords = 0;
                    table.rows = [];
                    table.updatePaggingInfo();

                    table.loading = false;
                    table.loaded = true;
                    
                    if (table.showLoading == true) {
                        this.apiLoader.hide(500);
                    }
                    complete();
                }
            }
        ).catch(() => {
            table.totalRecords = 0;
            table.rows = [];
            table.updatePaggingInfo();

            table.loading = false;
            table.loaded = true;
            
            if (table.showLoading == true) {
                this.apiLoader.hide(500);
            }
            complete();
        });
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/services/table.service.ts